module.exports = __webpack_public_path__ + "img/image02.eba6529c.jpg";